import React from "react";

import "./styles/style.scss";

import RadioCheck from "./RadioCheck";

export default RadioCheck;

export const Radio = (props) => <RadioCheck type="radio" {...props} />;
Radio.displayName = "Radio";

export const Checkbox = (props) => <RadioCheck type="checkbox" {...props} />;
Checkbox.displayName = "Checkbox";
